


export enum GtsAppTableNamesEnum {
    M_PO = 'm_po', // master production orders
    T_TRANS = 't_trans', // tracking transactions
    M_OP = 'm_op' // master operations
}
